module.exports = __webpack_public_path__ + "img/Alumno.8a24b304.png";